import { createAsyncThunk } from "@reduxjs/toolkit";
import { driver_all_pharmacy_list } from "../../../networking/urlEndPoints";

import Axios from "../../../networking/interceptor";

export const fetchAllPharmacyList = createAsyncThunk('fetchAllPharmacyList', async (_,{ rejectWithValue }) => {
    try {
       
        const response = await Axios.get(driver_all_pharmacy_list)
        const data = response.data
        return data;

    } catch (error) {
        return rejectWithValue(error.response)
    }
});